/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect ,useState,useCallback } from 'react';
import styles from './sidebarComponent.module.css';
import { ReactComponent as SelectedAdminTop } from '../../assets/SVG/sidebar/selectedAdminTop.svg';
import { ReactComponent as MedicalIcon } from '../../assets/SVG/sidebar/selectedClinicalTop.svg';
import { ReactComponent as SemenProcessingIcon } from '../../assets/SVG/sidebar/selectedLab.svg';
import { ReactComponent as AdminIcon } from '../../assets/SVG/Admin.svg';
import { ReactComponent as ClinicalIcon } from '../../assets/SVG/sidebar/selectedClinical.svg';
import { ReactComponent as LabIcon } from '../../assets/SVG/sidebar/Lab.svg';
import { ReactComponent as AIIcon } from '../../assets/SVG/AiIcon.svg';
import { ReactComponent as SelectedAI } from '../../assets/SVG/SelectedAIIcon.svg';
import { ReactComponent as VidaiLogoIcon } from '../../assets/SVG/Vidai Updated Logo.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate,useLocation, useParams  } from 'react-router-dom';
import { getPatientName } from '../../services/apiService';
import { BasicPatientInfo } from '../../types';
import DefaultImageMale from '../../assets/SVG/Default Profile - Male.svg';
import DefaultImageFemale from '../../assets/SVG/Default Profile - Female.svg';
import ImageWithSkeleton from '../customImageComponent';
import { setPatientDetails, setPatientId } from '../../services/sharedService';
import exitPatient from '../../assets/SVG/exitPatient.svg';
import { usePatientContext } from '../patinetProvider';
import { usePatientContext as useSubPatientContext } from '../SubPatinetProvider';
import { usePrint } from '../PrintProvider';
import PatientContextHeader from './PatientContextHeader';

const SideBarComponent = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const [transformWidth, setTransformWidth] = useState(-4);
  const [selectedMenu, setSelectedMenu] = useState('admin');
  const [selectedSubMenu, setSelectedSubMenu] = useState('admin');
  const [mainmenu, setMainMenu] = useState('admin');
  const [activeclinicalmenu, setActiveclinicalmenu] = useState('');
  const [activelabmenu, setActiveLabmenu] = useState('');
  const [activeSettingMenu, setActiveSettingMenu] = useState('');
  const [selectedClinicalmenu, setselectedClinicalmenu] = useState('');
  const [selectedlabtaskmenu, setSelectedLabtaskmenu] = useState('');
  const [selectedSettingsMenu, setselectedSettingsMenu] = useState('');

  const [user, setUser] = useState<BasicPatientInfo | null>(null);
  const [userP, setUserP] = useState<BasicPatientInfo | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { patientId, removePatient, addPatient } = usePatientContext();
  const { removeSubPatient, addSubPatient } = useSubPatientContext();
  const { TabOption,setTabOption } = usePrint();

  const { id } = useParams<{ id: string}>();

  useEffect(() => {
    if (patientId > 0) {
      getPatientName(patientId.toString()).then((response: BasicPatientInfo) => {
        setUserP({
          first_name: response.first_name,
          last_name: response.last_name,
          photo: response.photo,
          gender: response.gender
        });
      });
    } else {
      setUserP(null);
    }
     
  }, [patientId]);

  const changeMenu = useCallback((menuName: string): void => {;
    setMainMenu(menuName);
    if (menuName === 'admin' && location.pathname !== '/admin/appointments' && patientId <= 0) {
      navigate('/admin/appointments');
    }
    else if (menuName === 'admin' && patientId > 0){
      navigate(`/admin/registration/patient/${patientId}`);
    }
  }, [location.pathname, navigate, patientId]);

  const activesubmenu = useCallback( (e: string): void => {
    setSelectedSubMenu(e);
  },[]);

  const activeMenu = useCallback((e: string): void => {

    // if (e === selectedMenu) {
    //   if (e === 'Calendar') {
    //     setSelectedMenu('Calendar');
    //   }
    // }
    // else if(e === 'Stock'){
    //   activesubmenu('Stock');
    // }
    // eslint-disable-next-line no-console
    console.log(e);
    
    setSelectedMenu(e);

  },[]);

  // Inventory navigaiton. 
  useEffect(() => {
    // Handle Inventory (Stock, Stock Transfer, GRN, Purchase) and their submenus
    if (location.pathname.startsWith('/admin/inventory')) {
      activeMenu('Stock'); 

      if (location.pathname === '/admin/inventory/stock') {
        activesubmenu('Stock');
      } else if (location.pathname.startsWith('/admin/inventory/stock-transfer')) {
        activesubmenu('Stock Transfer');
      } else if (location.pathname.startsWith('/admin/inventory/grn')) {
        activesubmenu('GRN');
      } else if (location.pathname.startsWith('/admin/inventory/purchase')) {
        activesubmenu('Purchase');
      }
    } else {
      setSelectedMenu('admin');
      setSelectedSubMenu('');
    }
    
    if (location.pathname.startsWith('/admin/registration')) {
      setSelectedMenu('Registration');
    }
    if (location.pathname.startsWith('/admin/cima')) {
      setSelectedMenu('CIMA');
    }
  }, [location.pathname, activeMenu, activesubmenu]);
  
  
  // Function to handle submenu click
  const handleSubMenuClickItem = (submenu: string, path: string) => {
    activesubmenu(submenu);
    navigate(path);
  };

  const navToRegistration = () => {
    if (patientId > 0 ) {
      navigate(`/admin/registration/patient/${patientId}`);
    }else{
      navigate('/admin/registration/patient-list');
    }
  };

  const setActive = useCallback((index: number): void => {
    if (index === 1) {
      setTransformWidth(-4);
    } else if (index === 2) {
      setTransformWidth(57);
      if (patientId>0) {
        navigate(`/clinical/patients/summary/${patientId}`);
      } 
    }else if (index === 3) {
      
      if (patientId>0) {
        navigate(`/lab/embryology/oocyte-grading/${patientId}`);
      } else {
        navigate('/lab/dashboard');
        // navigate('/lab/embryology');
      }
      setTransformWidth(117);
    }
    else {
      navigate('/ai/reports/clinical');
      setTransformWidth(175);
    }
    setActiveIndex(index);
  }, [navigate, patientId]); 

  useEffect(() => {
    if (location.pathname === '/') {
      changeMenu('admin');
    }
  }, [location.pathname, changeMenu]);

  const [pathArray, setPathArray] = useState([location.pathname]);

  useEffect(() => {
    const segments = location.pathname.split('/').filter(Boolean);
    setPathArray(segments);

    // Only treat route :id as a patient id on patient-context routes
    const isPatientContextRoute = (
      location.pathname.includes('/clinical/patients/') ||
      location.pathname.includes('/admin/registration/patient/') ||
      location.pathname.includes('/admin/appointments/patient/') ||
      location.pathname.includes('/lab/andrology/') ||
      location.pathname.includes('/lab/embryology/')
    );

    if (id && isPatientContextRoute) {
      addPatient(Number(id));
      addSubPatient(Number(id));
    }

  }, [location.pathname, addPatient, id, addSubPatient]);

  useEffect(()=>{
    const newTabName = (pathArray[2] ?? null) as string | null;
    if (TabOption?.tabName !== newTabName) {
      setTabOption({ ...TabOption, tabName: newTabName });
    }
    switch (pathArray[0]) {
    case 'admin':
      setMainMenu('admin');
      setActiveIndex(1);
      setTransformWidth(-4);
      break;
    case 'clinical':
      setMainMenu('clinical');
      setActiveIndex(2);
      setTransformWidth(57);
      break;
    case 'lab':
      setMainMenu('lab');
      setActiveIndex(3);
      setTransformWidth(117);
      break;
    case 'ai':
      setMainMenu('setting');
      setActiveIndex(4);
      setTransformWidth(175);
      break;
    }
    if (location.pathname === '/clinical/dashboard') {
      setActiveclinicalmenu('dashboard');
    }
    if (location.pathname === '/lab/dashboard') {
      setActiveLabmenu('Dashboard');
    }
    if (location.pathname === '/lab/embryology') {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      activelabtask('Embryology');

    }
    if (location.pathname === '/ai/configuration/consent') {
      setActiveSettingMenu('configuration');
      setselectedSettingsMenu('consent');
    }
    if (location.pathname.includes('/ai/configuration/user')) {
      setActiveSettingMenu('configuration');
      setselectedSettingsMenu('user');
    }
    if (location.pathname.includes('/ai/reports/clinical')) {
      setActiveSettingMenu('reports');
      setselectedSettingsMenu('clinical');
    }

    if (location.pathname.includes('/ai/aiEmbryoGrader')) {
      setActiveSettingMenu('aiEmbryoGrader');
    }

    if (location.pathname === '/clinical/patients' && patientId > 0) {      
      switch (pathArray[2]) {
      case 'summary':
        navigate(`/clinical/patients/summary/${patientId}`);
        break;
      case 'medical-history':
        navigate(`/clinical/patients/medical-history/${patientId}`);
        break;
      case 'hpi':
        navigate(`/clinical/patients/hpi/${patientId}`);
        break;
      case 'examination':
        navigate(`/clinical/patients/examination/${patientId}`);

        break;
      case 'investigation':
        navigate(`/clinical/patients/investigation/${patientId}`);
        break;
      case 'treatment-plan':
        navigate(`/clinical/patients/treatment-plan/${patientId}`);
        break;
      case 'stimulation':
        navigate(`/clinical/patients/stimulation/${patientId}`);
  
        break;
      case 'outcome':
        navigate(`/clinical/patients/outcome/${patientId}`);
        break;
      case 'document':
        navigate(`/clinical/patients/document/${patientId}`);
        break;
      default:
        break;
      }
    }

    if (location.pathname === '/lab/andrology' && patientId > 0) {
      switch (pathArray[2]) {
      case 'semen-analysis':
        navigate(`/lab/andrology/semen-analysis/${patientId}`);
        break;
      case 'semen-processing':
        navigate(`/lab/andrology/semen-processing/${patientId}`);
        break;
      case 'semen-freezing':
        navigate(`/lab/andrology/semen-freezing/${patientId}`);
        break;
      case 'semen-thawing':
        navigate(`/lab/andrology/semen-thawing/${patientId}`);
        break;
      case 'IUI':
        navigate(`/lab/andrology/IUI/${patientId}`);
        break;
      default:
        break;
      }
    }    
    switch (pathArray[2]) {
    case 'summary':
      setActiveclinicalmenu('Clinical Profile');
      setselectedClinicalmenu('summary');
      break;
    case 'medical-history':
      setActiveclinicalmenu('Clinical Profile');
      setselectedClinicalmenu('medical-history');
      break;
    case 'hpi':
      setActiveclinicalmenu('Clinical Profile');
      setselectedClinicalmenu('hpi');
      break;
    case 'examination':
      setActiveclinicalmenu('Clinical Profile');
      setselectedClinicalmenu('examination');
      break;
    case 'investigation':
      setActiveclinicalmenu('Clinical Profile');
      setselectedClinicalmenu('investigation');
      break;
    case 'treatment-plan':
      setActiveclinicalmenu('Clinical Profile');
      setselectedClinicalmenu('treatment-plan');
      break;
    case 'cycle-overview':
      setActiveclinicalmenu('Clinical Profile');
      setselectedClinicalmenu('cycle-overview');
      break;
    case 'stimulation':
      setActiveclinicalmenu('Clinical Profile');
      setselectedClinicalmenu('stimulation');
      break;
    case 'document':
      setActiveclinicalmenu('Clinical Profile');
      setselectedClinicalmenu('document');
      break;
    case 'outcome':
      setActiveclinicalmenu('Clinical Profile');
      setselectedClinicalmenu('outcome');
      break;
    case 'surgery':
      setActiveclinicalmenu('Clinical Profile');
      setselectedClinicalmenu('surgery');
      break;
    case 'semen-analysis':
      setActiveLabmenu('Andrology');
      setSelectedLabtaskmenu('Semen Analysis');
      break;
    case 'semen-processing':
      setActiveLabmenu('Andrology');
      setSelectedLabtaskmenu('Semen Processing');
      break;
    case 'semen-freezing':
      setActiveLabmenu('Andrology');
      setSelectedLabtaskmenu('Semen Freezing');
      break;
    case 'semen-thawing':
      setActiveLabmenu('Andrology');
      setSelectedLabtaskmenu('Semen Thawing');
      break;
    case 'IUI':
      setActiveLabmenu('Andrology');
      setSelectedLabtaskmenu('IUI');
      break;
    case 'oocyte-grading':
      setActiveLabmenu('Embryology');
      setSelectedLabtaskmenu('Oocyte Grading');
      break;
    case 'embryo-culture':
      setActiveLabmenu('Embryology');
      setSelectedLabtaskmenu('Embryo Culture');
      break;
    case 'ai-embryo':
      setActiveLabmenu('Embryology');
      setSelectedLabtaskmenu('AI Embryo');
      break;  
    case 'pgta':
      setActiveLabmenu('Embryology');
      setSelectedLabtaskmenu('PGT');
      break;
    case 'cryo-thawing':
      setActiveLabmenu('Embryology');
      setSelectedLabtaskmenu('Cryo Thawing');
      break;
   
    case 'oocyte':
      setActiveLabmenu('Cryostorage');
      setSelectedLabtaskmenu('oocyte');
      break;
    case 'embryo':
      setActiveLabmenu('Cryostorage');
      setSelectedLabtaskmenu('embryo');
      break;
    case 'sperm':
      setActiveLabmenu('Cryostorage');
      setSelectedLabtaskmenu('sperm');
      break;
            
    default:
      break;
    }
  },[pathArray, location.pathname, navigate, patientId, TabOption, setTabOption]);
  useEffect(() => {

    if (location.pathname === '/admin/registration/patient-list') {
      activeMenu('Registration');
      activesubmenu('patient list');
    }
    if (location.pathname === '/admin/cima/patient-list') {
      activeMenu('CIMA');
      activesubmenu('patient list');
    }
    else if (location.pathname === '/admin/registration/patient-partner-registration') {
      activeMenu('Registration');

      activesubmenu('Registration Details');
      
    }
    // Calendar selection should be highlighted on all calendar routes
    if (location.pathname.startsWith('/admin/appointments')) {
      if (location.pathname.includes('/admin/appointments/patient')) {
        activeMenu('Calendar-patient');
      } else {
        activeMenu('Calendar');
        activesubmenu('Consultation');
      }
    }
    if (location.pathname === '/clinical/patients') {
      changeMenu('clinical');
      setActive(2);
      setActiveclinicalmenu('Clinical Profile');      
    }


    if (location.pathname.includes('admin/inventory')){
      activeMenu('Stock');
    }
    if (location.pathname.includes('/admin/registration/patient') && location.pathname !== '/admin/registration/patient' && !sessionStorage.getItem('prevRoute')){
      sessionStorage.setItem('prevRoute','/admin/registration/patient-list');
    }
    if (location.pathname.includes('/clinical/patients')&& location.pathname !== '/clinical/patients' && !sessionStorage.getItem('prevRoute')){
      sessionStorage.setItem('prevRoute','/clinical/patients');
    }

    if (location.pathname.includes('/admin/registration/patient/') || location.pathname.includes('admin/appointments/patient') ) {

      const id = location.pathname.split('/').pop();
      if (id && Number(id) > 0) {
        
        getPatientName(id.toString()).then((response: BasicPatientInfo) => {
          setUser({
            first_name: response.first_name,
            last_name: response.last_name,
            photo: response.photo,
            gender: response.gender
          });
        });
      }
    } else {setUser(null);}
  }, [location.pathname, activeMenu, activesubmenu, changeMenu, setActive]);

  const transformStyle = {
    transform: `translateX(${transformWidth}px)`,
  };


  const handleSubMenuClick = () => {
    navigate('/admin/registration/patient-list');
  };




  const activeclinicaltask = (e: string): void => {

    setActiveclinicalmenu(e);

  };

  const activelabtask = (e: string): void => {

    setActiveLabmenu(e);
    
  };

  const selectedClinicaltask = (e: string): void => {
    setselectedClinicalmenu(e);
    setTabOption({tabName: e, subOption: '', reportOptions:[]});
  };

  const activelasbtask = (e: string): void => {
    setSelectedLabtaskmenu(e);
  };
  const exitPatientProfile = ():void =>{
    sessionStorage.removeItem('patientId');
    const prev = sessionStorage.getItem('prevRoute');
    navigate(prev || '/admin/appointments');
    removePatient();
    removeSubPatient();
    setPatientDetails(null);
    setUserP(null);
    sessionStorage.removeItem('prevRoute');
  };
  function getUserNameAndProfilePic(): React.ReactNode {
    return (
      user && (
        <div className='d-flex'>
          <div>
            <img src={exitPatient} alt="exitPatient" width={'25px'} />
          </div>
          <div className={styles.userCard}>
            <ImageWithSkeleton src={user.photo} alt={'pc'} fallbackSrc={user.gender === 'FEMALE'? DefaultImageFemale: DefaultImageMale} height={'2rem'} width={'2rem'} borderRadius={'50%'}/>
            <label>Patient List</label>
          </div>
        </div>
      )
    );
  }

  function handlePatientAvatarClick(): void {
    if (patientId) {
      addPatient(patientId);
      setPatientId(patientId.toString());
      navigate(location.pathname + location.search, { replace: true });
    }
  }

  return (
    <div className={styles.contained}>
      <div className={styles.navigation}>
        <ul className='p-0 w-100'>
          <li
            className={`list ${activeIndex === 1 ? styles.active : ''}`}
            onClick={() => {
              setActive(1);
              changeMenu('admin');
            }}
          >
            <span>
              <span className={`icon ${activeIndex === 1 ? styles.clicked : ''}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {activeIndex === 1 ? <SelectedAdminTop className={styles.svgclass} /> : <AdminIcon  className={styles.svgclass}/>}
                <span style={{
                  fontSize: '12px',
                  color: activeIndex === 1 ? '#e17e61' : '#8F8888', // Dynamic color
                  fontWeight: activeIndex === 1 ? 600:500
                }}>Admin</span>


              </span>
            </span>
          </li>
          <li
            className={`list ${activeIndex === 2 ? styles.active : ''}`}
            onClick={() => {
              setActive(2);
              changeMenu('clinical');
              navigate(userP ? `/clinical/patients/summary/${patientId}` : '/clinical/dashboard');
            }}
          >
            <span>
              <span className={`icon ${activeIndex === 2 ? styles.clicked : ''}`}  style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {activeIndex === 2 ? <MedicalIcon className={styles.svgclass} /> : <ClinicalIcon className={styles.svgclass} />}
                <span style={{
                  fontSize: '12px',
                  color: activeIndex === 2 ? '#e17e61' : '#8F8888', // Dynamic color
                  fontWeight: activeIndex === 2 ? 600:500,
                }}>Clinical</span>
              </span>
            </span>
          </li>
          <li
            className={`list ${activeIndex === 3 ? styles.active : ''}`}
            onClick={() => {
              setActive(3);
              changeMenu('lab');
            }}
          >
            <span>
              <span className={`icon ${activeIndex === 3 ? styles.clicked : ''}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {activeIndex === 3 ? <SemenProcessingIcon className={styles.svgclass} /> : <LabIcon className={styles.svgclass} />}
                <span style={{
                  fontSize: '12px',
                  color: activeIndex === 3 ? '#e17e61' : '#8F8888', // Dynamic color
                  fontWeight: activeIndex === 3 ? 600:500,
                }}>Lab</span>

              </span>
            </span>
          </li>
          <li
            className={`list ${activeIndex === 3 ? styles.active : ''}`}
            onClick={() => {
              setActive(4);
              changeMenu('setting');
            }}
          >
            <span>
              <span className={`icon ${activeIndex === 4 ? styles.clicked : ''}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {activeIndex === 4 ? <SelectedAI className={styles.svgclass} /> : <AIIcon className={styles.svgclass} />}
                <span style={{
                  fontSize: '12px',
                  color: activeIndex === 4 ? '#e17e61' : '#8F8888', // Dynamic color
                  fontWeight: activeIndex === 4 ? 600:500,
                }}>Setting</span>

              </span>
            </span>
          </li>
          <svg
            style={{ fill: 'rgb(248, 247, 247)', ...transformStyle }}
            className={styles.indicator}
            width='94'
            height='56'
          >
            <ellipse cx='47' cy='30' rx='24' ry='30' />
            <path d='M24 20C24 20 28 55.9999 48 56L0 55.9997C18 55.9998 24 20 24 20Z' />
            <path d='M70 20C70 20 66 55.9999 46 56L94 55.9997C76 55.9998 70 20 70 20Z' />
          </svg>
        </ul>
      </div>
      {mainmenu === 'admin' && (
        <div className={`${styles.navigationsidebar}`}>
          <VidaiLogoIcon
            style={{
              position: 'absolute',
              bottom: '8%',
              width: '60%',
              left: ' 50px',
            }}
          >

          </VidaiLogoIcon>
          <h6 className={`${styles.versiontext}`}>Updated Version: 9.34</h6>
          <div
            className={`${styles.adminmenu} row`}
            style={{ '--bs-gutter-x': '0' } as React.CSSProperties}
          >
            {/* <h6
              className={`${styles.headeradmin} font-24 text-danger py-3 mb-0 bg-white px-0`}
            >
              <SelectedAdminIcon
                className={`${styles.imgadminicon}`}
              ></SelectedAdminIcon>
              <span className={styles.anchoradmin}>Admin</span>
            </h6> */}
            <ul
              className={`${styles.sidebarunorderedList} text-muted bg-white px-0`}
            >
              <div className={`${styles.orderlistDiv}`}>
                {location.pathname.includes('admin/appointments/patient') ? (
                // Show gender profile `li` if user exists
                  <li
                    className={`${selectedMenu === 'Calendar-patient'
                      ? styles.boldClass
                      : styles.orderlistLi
                    }`}
                    onClick={() => {
                      activeMenu('Calendar-patient');
                      exitPatientProfile();
                    }}
                  >
                    {getUserNameAndProfilePic()}
                  </li>
                ) : (
                  <li
                    className={`${selectedMenu === 'Calendar'
                      ? styles.boldClass
                      : styles.orderlistLi
                    }`}
                    onClick={() => {
                      if(patientId>0){
                        activeMenu('Calendar-patient');
                        navigate(`/admin/appointments/patient/${patientId}`);

                      }else{
                        navigate('/admin/appointments');
                        activeMenu('Calendar');
                      }
                    }}
                  >
                  Calendar
                  </li>
                )}

                
              </div>
              <div className={`${styles.orderlistDiv}`}>
                {user && location.pathname.includes('admin/registration/patient') ? (
                // Show gender profile `li` if user exists
                  <li
                    className={`${selectedMenu === 'GenderProfile'
                      ? styles.boldClass
                      : styles.orderlistLi
                    }`}
                    onClick={() => {
                      activeMenu('GenderProfile');
                      exitPatientProfile();
                    }}
                  >
                    {getUserNameAndProfilePic()}
                  </li>
                ) : (
                // Show registration `li` if user does not exist
                  <li
                    className={`${selectedMenu === 'Registration'
                      ? styles.boldClass
                      : styles.orderlistLi
                    }`}
                    onClick={() => {
                      activeMenu('Registration');
                      navToRegistration();
                    }}
                  >
    Registration 
                  </li>
                )}
              </div>
              <div className={`${styles.orderlistDiv}`}>
                <li
                  className={`${selectedMenu === 'CIMA'
                    ? styles.boldClass
                    : styles.orderlistLi
                  }`}
                  onClick={() => {
                    activeMenu('CIMA');
                    navigate('/admin/cima/patient-list');
                  }}
                >
                  CIMA Patient
                </li>
              </div>
              {selectedMenu === 'Registration' && location.pathname === '/admin/registration/patient-partner-registration' && (
                <div className={styles.mainclass}>
                  <ul className={`${styles.subunorderList}`}
                    style={{ display: 'none'}}                          // 07-07  hided the link (EMR-2623)
                  >
                    <li
                      className={`${selectedSubMenu === 'Registration Details'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() => activesubmenu('Registration Details')}
                    >
                      <label onClick={handleSubMenuClick}>Registration Details</label>
                    </li>

                  </ul>
                </div>
              )}
              <div className={`${styles.orderlistDiv}`}>
                <li
                  className={`${selectedMenu === 'Billing'
                    ? styles.boldClass
                    : styles.orderlistLi
                  }`}
                  onClick={() => {
                    window.open('https://stage1.fertivue.com:2502/#/Login', '_blank');
                  }}
                >
                  Billing
                </li>
              </div> 
              {selectedMenu === 'Billing' && (
                <div className={styles.mainclass}>
                  <ul className={`${styles.subunorderList}`}>
                    <li
                      className={`${selectedSubMenu === 'Eligibility'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() => activesubmenu('Eligibility')}
                    >
                      Eligibility
                    </li>
                    <li
                      className={`${selectedSubMenu === 'Package Details'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() => activesubmenu('Package Details')}
                    >
                      Package Details
                    </li>
                    <li
                      className={`${selectedSubMenu === 'Authorization'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() => activesubmenu('Authorization')}
                    >
                      Authorization
                    </li>
                    <li
                      className={`${selectedSubMenu === 'Generate Invoice'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() => activesubmenu('Generate Invoice')}
                    >
                      Generate Invoice
                    </li>
                    <li
                      className={`${selectedSubMenu === 'Claim Submission'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() => activesubmenu('Claim Submission')}
                    >
                      Claim Submission
                    </li>
                    <li
                      className={`${selectedSubMenu === 'Collect Advance'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() => activesubmenu('Collect Advance')}
                    >
                      Collect Advance
                    </li>
                    <li
                      className={`${selectedSubMenu === 'Refund'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() => activesubmenu('Refund')}
                    >
                      Refund
                    </li>
                    <li
                      className={`${selectedSubMenu === 'Pharmacy'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() => activesubmenu('Pharmacy')}
                    >
                      Pharmacy
                    </li>
                  </ul>
                </div>
              )}
              <div className={`${styles.orderlistDiv}`}>
                <li
                  className={`${selectedMenu === 'Stock' ? styles.boldClass : styles.orderlistLi}`}
                  // onClick={() => handleMenuClick('Stock')}
                  onClick={() => {
                    window.open('https://stage1.fertivue.com:2502/#/Login', '_blank');
                  }}
                >
                  Inventory
                </li>
                {selectedMenu === 'Stock' && (
                  <div className={styles.mainclass}>
                    <ul className={`${styles.subunorderList}`}>
                      <li
                        className={`${selectedSubMenu === 'Stock' ? `${styles.subunorderedlistLiChecked} ${styles.active}` : styles.subunorderedlistLi}`}
                        onClick={() => handleSubMenuClickItem('Stock', '/admin/inventory/stock')}
                      >
                        Stock
                      </li>
                      <li
                        className={`${selectedSubMenu === 'Stock Transfer' ? `${styles.subunorderedlistLiChecked} ${styles.active}` : styles.subunorderedlistLi}`}
                        onClick={() => handleSubMenuClickItem('Stock Transfer', '/admin/inventory/stock-transfer')}
                      >
                        Stock Transfer
                      </li>
                      <li
                        className={`${selectedSubMenu === 'GRN' ? `${styles.subunorderedlistLiChecked} ${styles.active}` : styles.subunorderedlistLi}`}
                        onClick={() => handleSubMenuClickItem('GRN', '/admin/inventory/grn/prospective')}
                      >
                        GRN
                      </li>
                      <li
                        className={`${selectedSubMenu === 'Return' ? `${styles.subunorderedlistLiChecked} ${styles.active}` : styles.subunorderedlistLi}`}
                        onClick={() => handleSubMenuClickItem('Return', '/admin/inventory/return')}
                      >
                        Return
                      </li>
                      <li
                        className={`${selectedSubMenu === 'Purchase' ? `${styles.subunorderedlistLiChecked} ${styles.active}` : styles.subunorderedlistLi}`}
                        onClick={() => handleSubMenuClickItem('Purchase', '/admin/inventory/purchase/requisition')}
                      >
                        Purchase
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </ul>
          </div>
        </div>
      )}

      {mainmenu === 'clinical' && (
        <div className={styles.navigationsidebar}>
          <VidaiLogoIcon
            style={{
              position: 'absolute',
              bottom: '8%',
              width: '60%',
              left: ' 50px',
            }}
          >

          </VidaiLogoIcon>
          <h6 className={`${styles.versiontext}`}>Updated Version: 9.34</h6>

          <div
            className={`${styles.adminmenu} row`}
            style={{ '--bs-gutter-x': '0' } as React.CSSProperties}
          >
            {/* <h6
              className={`${styles.headeradmin} font-24 text-danger py-3 mb-0 bg-white px-0`}
            >
              <MedicalIcon className={`${styles.imgadminicon}`}> </MedicalIcon>
              <span className={styles.anchoradmin}>Clinical</span>
            </h6> */}
            <div>
              <ul
                className={`${styles.sidebarunorderedList} text-muted bg-white p-0 `}
                style={{borderRadius:'30px'}}
              >

                <div  style={
                  userP
                    ? {
                      background: 'linear-gradient(199.55deg, #EEEEEE 20.06%, rgba(243, 243, 243, 0.547773) 75.62%, rgba(232, 234, 236, 0) 110.17%)' ,
                      borderRadius: '30px'
                    }
                    : {
                      borderRadius: '30px'
                    }

                }>
                  <div className={`${styles.orderlistDiv} py-3`} style={{borderRadius:'20px 20px 20px 0px'}}
                  >
                    {!userP && 
                    (
                      <li
                        className={`${activeclinicalmenu === 'dashboard' 
                          ? (userP ? styles.boldClass1 : styles.boldClass) 
                          : styles.orderlistLi}`}

                      >

                        <div className='d-flex' onClick={() => { activeclinicaltask('dashboard'); navigate('/clinical/dashboard'); } }>
                          <div>
                            <p>Dashboard</p>
                          </div>
                        </div>
                      </li>
                    )
                    }
                    
                    <li
                      className={`${activeclinicalmenu === 'Clinical Profile' 
                        ? (userP ? styles.boldClass1 : styles.boldClass) 
                        : styles.orderlistLi}`}

                    >
                      {userP ? (
                        <PatientContextHeader
                          photo={userP.photo}
                          gender={userP.gender}
                          label={'Patient Profile'}
                          onExit={exitPatientProfile}
                          onAvatarClick={handlePatientAvatarClick}
                        />
                      ) : (
                        <div>

                          <div className='d-flex' onClick={() => { activeclinicaltask('Clinical Profile'); navigate('/clinical/patients'); } }>
                            <div>
                              <p>Patient List</p>
                            </div>
                          </div>
                        
                        </div>
                      )}
                      {/* Clinical Profile */}
                    </li>


                  </div>
                  {activeclinicalmenu === 'Clinical Profile'&& patientId > 0 && (
                    <div style={{backgroundColor:'#FFF'}}>
                      <ul className={`${styles.subunorderList}`}>
                        {[
                          { key: 'summary', label: 'Summary', path: (id: number) => `/clinical/patients/summary/${id}` },
                          { key: 'medical-history', label: 'Medical History', path: (id: number) => `/clinical/patients/medical-history/${id}` },
                          { key: 'hpi', label: 'HPI', path: (id: number) => `/clinical/patients/hpi/${id}` },
                          { key: 'examination', label: 'Examination', path: (id: number) => `/clinical/patients/examination/${id}` },
                          { key: 'investigation', label: 'Investigation', path: (id: number) => `/clinical/patients/investigation/${id}`, dividerAfter: true },
                          { key: 'treatment-plan', label: 'Treatment Plan', path: (id: number) => `/clinical/patients/treatment-plan/${id}` },
                          { key: 'cycle-overview', label: 'Cycle Overview', path: (id: number) => `/clinical/patients/cycle-overview/${id}` },
                          { key: 'stimulation', label: 'Stimulation', path: (id: number) => `/clinical/patients/stimulation/${id}` },
                          { key: 'surgery', label: 'Surgery', path: (id: number) => `/clinical/patients/surgery/${id}` },
                          { key: 'outcome', label: 'Outcome', path: (id: number) => `/clinical/patients/outcome/${id}` },
                          { key: 'document', label: 'Documents', path: (id: number) => `/clinical/patients/document/${id}` },
                        ].map((item) => (
                          <React.Fragment key={item.key}>
                            <li
                              className={`${selectedClinicalmenu === item.key
                                ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                                : styles.subunorderedlistLi
                              }`}
                              onClick={() => { selectedClinicaltask(item.key); navigate(item.path(patientId)); }}
                            >
                              {item.label}
                            </li>
                            {item.dividerAfter ? <hr/> : null}
                          </React.Fragment>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

                {activeclinicalmenu === 'Treatment' && (
                  <div>
                    <ul className={`${styles.subunorderList}`}>
                      <li
                        className={`${selectedClinicalmenu === 'Treatment Plan'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => selectedClinicaltask('Treatment Plan')}
                      >
                      Treatment Plan
                      </li>
                      <li
                        className={`${selectedClinicalmenu === 'ART Cycle'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => selectedClinicaltask('ART Cycle')}
                      >
                      ART Cycle
                      </li>
                      <li
                        className={`${selectedClinicalmenu === 'Stimulation'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => selectedClinicaltask('Stimulation')}
                      >
                      Stimulation
                      </li>
                      <li
                        className={`${selectedClinicalmenu === 'Surgery'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => selectedClinicaltask('Surgery')}
                      >
                      Surgery
                      </li>
                      <li
                        className={`${selectedClinicalmenu === 'Outcome'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => selectedClinicaltask('Outcome')}
                      >
                      Outcome
                      </li>
                    </ul>
                  </div>
                )}
              </ul>
            </div>
          </div>
        </div>
      )}

      {mainmenu === 'lab' && (
        <div className={styles.navigationsidebar}>
          <VidaiLogoIcon
            style={{
              position: 'absolute',
              bottom: '8%',
              width: '60%',
              left: '40px',
            }}
          >

          </VidaiLogoIcon>
          <h6 className={`${styles.versiontext}`}>Updated Version: 9.34</h6>

          <div
            className={`${styles.adminmenu} row`}
            style={{ '--bs-gutter-x': '0' } as React.CSSProperties}
          >
            {/* <h6
              className={`${styles.headeradmin} font-24 text-danger py-3 mb-0 bg-white px-0`}
            >
              <SemenProcessingIcon className={`${styles.imgadminicon}`}>
                {' '}
              </SemenProcessingIcon>
              <span className={styles.anchoradmin}>Lab</span>
            </h6> */}
            <ul
              className={`${styles.sidebarunorderedList} text-muted bg-white px-0`}
            >

              <div  style={
                userP
                  ? {
                    background: 'linear-gradient(199.55deg, #EEEEEE 20.06%, rgba(243, 243, 243, 0.547773) 75.62%, rgba(232, 234, 236, 0) 110.17%)' ,
                    borderRadius: '30px'
                  }
                  : {
                    borderRadius: '30px'
                  }

              }>
                
                {!userP &&(
                  <div className={`${styles.orderlistDiv} `} style={{borderRadius:'20px 20px 20px 0px'}}>
                    <li
                      className={`${activelabmenu === 'Dashboard' 
                        ? (userP ? styles.boldClass1 : styles.boldClass) 
                        : styles.orderlistLi}`}

                    >
                      <div
                        onClick={() => {activelasbtask('Dashboard'); navigate('/lab/dashboard');}}
                      >
                        <p>Dashboard</p>
                      </div>
                    </li>
                  </div>
                )}
                <div className={`${styles.orderlistDiv} `} style={{borderRadius:'20px 20px 20px 0px'}}>
                 
                  <li
                    className={`${activelabmenu === 'Embryology' 
                      ? (userP ? styles.boldClass1 : styles.boldClass) 
                      : styles.orderlistLi}`}

                  >
                    {(userP && activelabmenu === 'Embryology') ? (
                      <PatientContextHeader
                        photo={userP.photo}
                        gender={userP.gender}
                        label={'Exit Patient'}
                        onExit={exitPatientProfile}
                        onAvatarClick={handlePatientAvatarClick}
                      />
                    ) : (
                      <div className='d-flex'  onClick={() => {activelabtask('Embryology');  if (patientId > 0) {
                        navigate(`/lab/embryology/oocyte-grading/${patientId}`);
                      } else {
                        navigate('/lab/embryology');
                      };}}>
                        <div>
                          <p>Embryology</p>
                        </div>
                      </div>
                    )}
                    {/* Clinical Profile */}
                  </li>
                </div>
                {activelabmenu === 'Embryology'&& patientId>0 && (
                  <div style={{backgroundColor:'#FFF'}}>

                    <ul className={`${styles.subunorderList}`}>
                      <li
                        className={`${selectedlabtaskmenu === 'Oocyte Grading'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => {activelasbtask('Oocyte Grading'); navigate(`/lab/embryology/oocyte-grading/${patientId}`);}}
                      >
                      Oocyte Grading
                      </li>
                      <li
                        className={`${selectedlabtaskmenu === 'Embryo Culture'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi 
                        }`}
                        onClick={() => {activelasbtask('Embryo Culture'); navigate(`/lab/embryology/embryo-culture/${patientId}`);}}
                      >
                      Embryo Culture
                      </li>
                      <li
                        className={`${selectedlabtaskmenu === 'AI Embryo'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => {activelasbtask('AI Embryo'); navigate(`/lab/embryology/ai-embryo/${patientId}`);}}
                      >
                      AI Embryo
                      </li>
                      <li
                        className={`${selectedlabtaskmenu === 'PGT'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => {activelasbtask('PGT');navigate(`/lab/embryology/pgta/${patientId}`);}}
                      > 
                      PGT 
                      </li>
                      <li
                        className={`${selectedlabtaskmenu === 'Cryo Thawing'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => {activelasbtask('Cryo Thawing');navigate(`/lab/embryology/cryo-thawing/${patientId}`);}}
                      >
                      Cryo Thawing
                      </li>
                    </ul>
                  </div>
                )}
              </div>


              <div  style={
                userP
                  ? {
                    background: 'linear-gradient(199.55deg, #EEEEEE 20.06%, rgba(243, 243, 243, 0.547773) 75.62%, rgba(232, 234, 236, 0) 110.17%)' ,
                    borderRadius: '30px'
                  }
                  : {
                    borderRadius: '30px'
                  }

              }>
                <div className={`${styles.orderlistDiv} `} style={{borderRadius:'20px 20px 20px 0px'}}
                >
                  <li
                    className={`${activelabmenu === 'Andrology' 
                      ? (userP ? styles.boldClass1 : styles.boldClass) 
                      : styles.orderlistLi}`}

                  >
                    {(userP && activelabmenu === 'Andrology') ? (
                      <PatientContextHeader
                        photo={userP.photo}
                        gender={userP.gender}
                        label={'Exit Patient'}
                        onExit={exitPatientProfile}
                        onAvatarClick={handlePatientAvatarClick}
                      />
                    ) : (
                      <div className='d-flex'  onClick={() => {activelabtask('Andrology');  if (patientId>0) {
                        navigate(`/lab/andrology/semen-analysis/${patientId}`);
                      } else {
                        navigate('/lab/andrology');
                      };}}>
                        <div>
                          <p>Andrology</p>
                        </div>
                      </div>
                    )}
                    {/* Clinical Profile */}
                  </li>
                </div>
                {activelabmenu === 'Andrology'&& patientId>0 && (
                  <div style={{backgroundColor:'#FFF'}}>

                    <ul className={`${styles.subunorderList}`}>
                      <li
                        className={`${selectedlabtaskmenu === 'Semen Analysis'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => {activelasbtask('Semen Analysis'); navigate(`/lab/andrology/semen-analysis/${patientId}`);}}
                      >
                      Semen Analysis
                      </li>
                      <li
                        className={`${selectedlabtaskmenu === 'Semen Processing'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => {activelasbtask('Semen Processing'); navigate(`/lab/andrology/semen-processing/${patientId}`);}}
                      >
                      Semen Processing
                      </li>
                      <li
                        className={`${selectedlabtaskmenu === 'Semen Freezing'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => {activelasbtask('Semen Freezing'); navigate(`/lab/andrology/semen-freezing/${patientId}`);}}
                      >
                      Semen Freezing
                      </li>
                      <li
                        className={`${selectedlabtaskmenu === 'Semen Thawing'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => {activelasbtask('Semen Thawing');navigate(`/lab/andrology/semen-thawing/${patientId}`);}}
                      >
                      Semen Thawing
                      </li>
                      <li
                        className={`${selectedlabtaskmenu === 'IUI'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() => {activelasbtask('IUI');navigate(`/lab/andrology/IUI/${patientId}`);}}
                      >
                      IUI
                      </li>
                    </ul>
                  </div>
                )}
              </div>

              {!userP &&(

                <div className={`${styles.orderlistDiv}`} style={{borderRadius:'20px 20px 20px 0px'}}
                >
                  <li
                    className={`${activelabmenu === 'Cryostorage' 
                      ? (userP ? styles.boldClass1 : styles.boldClass1) 
                      : styles.orderlistLi}`}

                  >
                    <div className='d-flex'  onClick={() => {activelabtask('Cryostorage');  if (patientId>0) {
                      navigate('/lab/Cryostorage/oocyte');
                    } else {
                      navigate('/lab/Cryostorage/oocyte');
                    };}}>
                      <div>
                        <p>Cryostorage</p>
                      </div>
                    </div>
                  </li>
                </div>
              )}
              {activelabmenu === 'Cryostorage' && (
                <div style={{backgroundColor:'#FFF'}}>

                  <ul className={`${styles.subunorderList}`}>
                    <li
                      className={`${selectedlabtaskmenu === 'oocyte'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() => {activelasbtask('oocyte'); navigate('/lab/cryostorage/oocyte');}}
                    >
                      Oocyte
                    </li>                      
                    <li
                      className={`${selectedlabtaskmenu === 'embryo'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() => {activelasbtask('embryo'); navigate('/lab/cryostorage/embryo');}}
                    >
                      Embryo
                    </li>
                      
                    <li
                      className={`${selectedlabtaskmenu === 'sperm'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() => {activelasbtask('sperm'); navigate('/lab/cryostorage/sperm');}}
                    >
                      Sperm
                    </li>
                  </ul>
                </div>
              )}


              {/* <div className={`${styles.orderlistDiv}`}>
                <li
                  className={`${activelabmenu === 'Cryostorage'
                    ? styles.boldClass
                    : styles.orderlistLi
                  }`}
                  onClick={() => activelabtask('Cryostorage')}
                >
                  Cryostorage
                </li>
              </div> */}
            </ul>
          </div>
        </div>
      )}


      {/* setting tabbbbbbbbbbbbb 111111111111111*/}



      {mainmenu === 'setting' && (
        <div className={styles.navigationsidebar}>
          <VidaiLogoIcon
            style={{
              position: 'absolute',
              bottom: '8%',
              width: '60%',
              left: '40px',
            }}
          >

          </VidaiLogoIcon>
          <h6 className={`${styles.versiontext}`}>Updated Version: 9.34</h6>

          <div
            className={`${styles.adminmenu} row`}
            style={{ '--bs-gutter-x': '0' } as React.CSSProperties}
          >
            <ul
              className={`${styles.sidebarunorderedList} text-muted bg-white px-0`}
            >

              <div  style={
              
                    
                {background: 'linear-gradient(199.55deg, #EEEEEE 20.06%, rgba(243, 243, 243, 0.547773) 75.62%, rgba(232, 234, 236, 0) 110.17%)' ,
                  borderRadius: '20px 20px 0px 0px'}
              

              }>

                <div className={`${styles.orderlistDiv} `} style={activeSettingMenu === 'aiEmbryoGrader'?{borderRadius:'20px 20px 0px 0px'}:{borderRadius:'20px 20px 0px 0px'}}>
                  <li
                    className={`${activeSettingMenu === 'aiEmbryoGrader'?  styles.boldClass12: styles.orderlistLi}`}
                    onClick={() =>{ setActiveSettingMenu('aiEmbryoGrader'); navigate('ai/aiEmbryoGrader');}}
                  >
                      AI Embryo Grader
                  </li>

                </div>


                <div className={`${styles.orderlistDiv} `} style={activeSettingMenu === 'reports'?{borderRadius:'0px 0px 20px 0px'}:{borderRadius:'0px 0px 0px 0px'}}>
                  <li
                    className={`${activeSettingMenu === 'reports'?  styles.boldClass12: styles.orderlistLi}`}
                    onClick={() =>{ setActiveSettingMenu('reports'); navigate('ai/reports/clinical');}}
                  >
                      Reports
                  </li>

                </div>

                {activeSettingMenu === 'reports'  && (
                  <div style={{backgroundColor:'#FFF'}}>
                    <ul className={`${styles.subunorderList}`}>
                      <li
                        className={`${selectedSettingsMenu === 'clinical'
                          ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                          : styles.subunorderedlistLi
                        }`}
                        onClick={() =>{ setselectedSettingsMenu('clinical'); navigate('ai/reports/clinical');}}
                      >
                         Clinical
                      </li>
                    </ul>
                  </div>
                )}

                <div className={`${styles.orderlistDiv} `} style={activeSettingMenu === 'configuration'?{borderRadius:'0px 0px 20px 0px'}:{borderRadius:'0px'}}>
                  <li
                    className={`${activeSettingMenu === 'configuration'
                      ? styles.boldClass
                      : styles.orderlistLi
                    }`}
                    onClick={() => {setActiveSettingMenu('configuration'); navigate('ai/configuration/consent');}}
                  >
                  Configuration
                  </li>
                </div>




              </div>
              {activeSettingMenu === 'configuration' && (
                <div className={styles.mainclass}>
                  <ul className={`${styles.subunorderList}`}>
                    <li
                      className={`${selectedSettingsMenu === 'user'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() =>{ setselectedSettingsMenu('user'); navigate('ai/configuration/user');}}
                    >
                      User
                    </li>
                    <li
                      className={`${selectedSettingsMenu === 'consent'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() =>{ setselectedSettingsMenu('consent'); navigate('ai/configuration/consent');}}
                    >
                      Consent
                    </li>
      
      
                    <li
                      className={`${selectedSettingsMenu === 'clinic'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() =>{ setselectedSettingsMenu('clinic'); navigate('ai/configuration/clinic');}}
                    >
                      Clinic
                    </li>

                    {/* 
                    <li
                      className={`${selectedSettingsMenu === 'pageConfig'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() =>{ setselectedSettingsMenu('pageConfig'); navigate('ai/configuration/pageConfig');}}
                    >
                      Page
                    </li> */}

                  </ul>
                </div>
              )}

            </ul>
          </div>
        </div>
      )}

      {/* setting tabbbbbbbbbbbbb 222222222222222*/}

      {/* {mainmenu === 'setting' && (
        <div className={styles.navigationsidebar}>
          <VidaiLogoIcon
            style={{
              position: 'absolute',
              bottom: '8%',
              width: '60%',
              left: ' 50px',
            }}
          >

          </VidaiLogoIcon>
          <h6 className={`${styles.versiontext}`}>Updated Version: 9.34</h6>

          <div
            className={`${styles.adminmenu} row`}
            style={{ '--bs-gutter-x': '0' } as React.CSSProperties}
          >
            <div>
              <ul
                className={`${styles.sidebarunorderedList} text-muted bg-white p-0 `}
                style={{borderRadius:'30px'}}
              >

                <div  style={{background: 'linear-gradient(199.55deg, #EEEEEE 20.06%, rgba(243, 243, 243, 0.547773) 75.62%, rgba(232, 234, 236, 0) 110.17%)' ,borderRadius: '30px'}}>

                
                </div>
              </ul>
            </div>
          </div>
        </div>
      )} */}

      {/* {mainmenu === 'setting' && (
        <div className={`${styles.navigationsidebar}`}>
          <VidaiLogoIcon
            style={{
              position: 'absolute',
              bottom: '8%',
              width: '60%',
              left: ' 50px',
            }}
          >

          </VidaiLogoIcon>
          <h6 className={`${styles.versiontext}`}>Updated Version: 9.34</h6>
          <div
            className={`${styles.adminmenu} row`}
            style={{ '--bs-gutter-x': '0' } as React.CSSProperties}
          >
        
            <ul
              className={`${styles.sidebarunorderedList} text-muted bg-white px-0 pb-5`}
            >
              <div className={`${styles.orderlistDiv}`}>
                <li
                  className={`${activeSettingMenu === 'configuration'
                    ? styles.boldClass
                    : styles.orderlistLi
                  }`}
                  onClick={() => setActiveSettingMenu('configuration')}
                >
                  Configuration
                </li>
              </div>
             
              {activeSettingMenu === 'configuration' && (
                <div className={styles.mainclass}>
                  <ul className={`${styles.subunorderList}`}>
                    <li
                      className={`${selectedSettingsMenu === 'consent'
                        ? `${styles.subunorderedlistLiChecked} ${styles.active}`
                        : styles.subunorderedlistLi
                      }`}
                      onClick={() =>{ setselectedSettingsMenu('consent'); navigate('ai/configuration/consent');}}
                    >
                      Consent
                    </li>
      
                  </ul>
                </div>
              )}
            </ul>
          </div>
        </div>
      )} */}

    </div>
  );
};

export default SideBarComponent;